<app-nav-bar/>
<app-hero-pages/>
<app-services-movi-link/>
<app-how-to-apply-service/>
<app-ambulance/>
<app-footer-persona/>
<app-float-button/>
